import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';
import Loader from 'Components/Loader';
import { TextField, MenuItem, Button, Snackbar } from '@material-ui/core';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import axios from 'Axios';
import connect from 'react-redux/es/connect/connect';
import { getAllAdminUsersDataByType } from 'Actions/adminActions';
import Switch from '@material-ui/core/Switch';
import Slide from '@material-ui/core/Slide';

function TransitionUp(props) {
  return <Slide {...props} direction="up" />;
}

const StyledSwitch = styled.div`
  margin-top: 20px;
  margin-left: -15px;
`;

const DownloadButton = styled(Button)`
  background: #fff !important;
  margin-right: 16px !important;
`;

const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 500px;
  background-color: rgb(234, 234, 234);
  padding: 20px;
`;

const regexArup = /^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(arup)\.com$/i;
const regexComp = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;

const styles = theme => ({
  root: {
    margin: 0,
    padding: '20px',
    backgroundColor: 'rgb(255, 202, 40)',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  closeButton: {
    position: 'absolute',
    right: '10px',
    top: '10px',
    color: 'grey',
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: '20px',
    backgroundColor: 'rgb(234, 234, 234)',
  },
}))(MuiDialogActions);

class CustomizedDialogs extends React.Component {
  state = {
    role: '',
    disabledBtn: true,
    openSnackbar: false,
    email: '',
    responseFromInviteUser: '',
    SnackbarMsg: 'Both role and email are required',
    useOnlyArup: this.props.arupUsers,
    sending: false,
    validateEmailMsg: !this.props.arupUsers
      ? 'Email must be in valid format: xxxxxxxxxxx@xxxx.com'
      : 'Email must be in valid format: xxxxxxxxxxx@arup.com',
  };

  componentDidMount() {
    const role = this.props.arupUsers ? 'DESIGNER_LIGHTING' : 'MANUFACTURER';
    this.setState({
      role,
    });
  }

  handleChangeRole = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleOpenSncakbar = () => {
    this.setState({ openSnackbar: true });
  };

  handleCloseSncakbar = () => {
    this.setState({ openSnackbar: false });
  };

  inviteUser = () => {
    if (this.state.role === '' || this.state.email === '') {
      this.setState({
        openSnackbar: true,
        SnackbarMsg: 'Both role and email are required',
      });
    } else {
      this.sendIvitation();
    }
  };

  sendIvitation = () => {
    this.setState({ disabledBtn: true, sending: true });
    axios
      .post('invite', {
        email: this.state.email,
        role: this.state.role,
        hasArupDomain: this.state.useOnlyArup,
      })
      .then(response => {
        if (response.data) {
          this.setState(
            {
              SnackbarMsg: 'The invitation has been sent',
              responseFromInviteUser: response.data,
              email: '',
              disabledBtn: false,
              sending: false,
            },
            () => {
              this.handleOpenSncakbar();
              this.props.getAllAdminUsersDataByType(
                this.props.arupUsers,
                'pending'
              );
              this.props.goToPendingUsers();
            }
          );
        }
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        this.setState(
          {
            SnackbarMsg: errorMessage,
            sending: false,
          },
          () => {
            this.handleOpenSncakbar();
          }
        );
      });
  };

  handleChangeEmail = event => {
    this.setState({ [event.target.name]: event.target.value });
    if (
      event.target.value.match(
        this.state.useOnlyArup ? regexArup : regexComp
      ) !== null
    ) {
      this.setState({ validateEmailMsg: '', disabledBtn: false });
    } else {
      this.setState({
        validateEmailMsg: this.state.useOnlyArup
          ? 'Email must be in valid format: xxxxxxxxxxx@arup.com'
          : 'Email must be in valid format: xxxxxxxxxxx@xxxx.com',
        disabledBtn: true,
      });
    }
  };

  validateEmail = () => {
    if (
      this.state.email.match(this.state.useOnlyArup ? regexArup : regexComp) !==
      null
    ) {
      this.setState({ validateEmailMsg: '', disabledBtn: false });
    } else {
      this.setState({
        disabledBtn: true,
      });
    }
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked }, () => {
      this.setState(
        {
          validateEmailMsg: this.state.useOnlyArup
            ? 'Email must be in valid format: xxxxxxxxxxx@arup.com'
            : 'Email must be in valid format: xxxxxxxxxxx@xxxx.com',
        },
        this.validateEmail
      );
    });
  };

  render() {
    const props = this.props;
    const classes = this.props.classes;
    return (
      <Dialog
        onClose={props.closeMessageDialog}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={props.closeMessageDialog}
        >
          ARUP Luminaire Broker
        </DialogTitle>
        <DialogContent>
          <TextField
            id="roleSelector"
            value={this.state.role}
            onChange={this.handleChangeRole}
            select
            label="Role"
            name="role"
            disabled={!this.props.arupUsers}
          >
            {this.props.arupUsers ? (
              [
                <MenuItem key={'DESIGNER_LIGHTING'} value={'DESIGNER_LIGHTING'}>
                  Lighting designer
                </MenuItem>,
                <MenuItem
                  key={'ELECTRICAL_ENGINEER'}
                  value={'ELECTRICAL_ENGINEER'}
                >
                  Electrical engineer
                </MenuItem>,
                <MenuItem key={'ARCHITECT'} value={'ARCHITECT'}>
                  Architect
                </MenuItem>,
                <MenuItem key={'INTERIOR_DESIGNER'} value={'INTERIOR_DESIGNER'}>
                  Interior designer
                </MenuItem>,
                <MenuItem key={'AV_DESIGNER'} value={'AV_DESIGNER'}>
                  AV designer
                </MenuItem>,
              ]
            ) : (
              <MenuItem value={'MANUFACTURER'}>Manufacturer</MenuItem>
            )}
          </TextField>
          <StyledSwitch>
            <Switch
              checked={this.state.useOnlyArup}
              onChange={this.handleChange('useOnlyArup')}
              value="useOnlyArup"
            />
            Use only arup email domain
          </StyledSwitch>
          <TextField
            type="email"
            helperText={this.state.validateEmailMsg}
            value={this.state.email}
            fullWidth
            label="E-mail :"
            //   variant="outlined"
            id="inviteEmail"
            name="email"
            onChange={this.handleChangeEmail}
          />

          <Snackbar
            open={this.state.openSnackbar}
            // autoHideDuration={4000}
            TransitionComponent={TransitionUp}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            onClose={this.handleCloseSncakbar}
            ContentProps={{
              'aria-describedby': 'snackbar-fab-message-id',
              className: classes.snackbarContent,
            }}
            message={
              <span id="snackbar-fab-message-id">{this.state.SnackbarMsg}</span>
            }
            action={
              <Button
                color="inherit"
                size="small"
                onClick={this.handleCloseSncakbar}
              >
                close
              </Button>
            }
            className={classes.snackbar}
          />
        </DialogContent>
        <DialogActions>
          <DownloadButton
            disabled={this.state.disabledBtn}
            autoFocus
            onClick={this.inviteUser}
            variant="contained"
            className="t-weight-b criteria-button"
          >
            <React.Fragment>
              <Loader isLoading={this.state.sending} size={32} />
              <p
                style={{
                  visibility: this.state.sending ? 'hidden' : 'visible',
                }}
              >
                Invite user
              </p>
            </React.Fragment>
          </DownloadButton>
        </DialogActions>
      </Dialog>
    );
  }
}

CustomizedDialogs.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => ({
  getAllAdminUsersDataByType: (arupUsers, filterBy) => {
    dispatch(getAllAdminUsersDataByType(arupUsers, filterBy));
  },
});
export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(CustomizedDialogs));
